import { Close } from '@mui/icons-material';
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import { getFactoringRequestsReceivedToApprove } from 'lib/api/factoring';
import CustomButton from 'lib/designSystem/Button';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import HeaderWithActions from 'lib/designSystem/HeaderWithActions';
import EnhancedTable from 'lib/designSystem/Table';
import React from 'react';
import { useDispatch } from 'react-redux';

export interface FactoringRequestToApprove {
  id: number;
  status: string;
  sender: string;
  recipient: string;
  validUntil: Date;
  paymentDate: Date;
  amount: number;
  extraData: boolean;
  relation?: any;
  businessId: number;
  businessIdentifier: string;
  businessName: string;
  createdAt: string;
  minutesSinceUpdate?: number;
  exception?: boolean;
  turn?: string;
  recipientName?: string;
  createdBy?: string;
}

interface MyRequestsToApproveProps {
  open: boolean;
  onClose: () => void;
  handleDetails: (id: number) => void;
}

const dataHeaders = [
  { key: 'id', label: 'ID', type: 'numeric-id' },
  { key: 'exception', label: 'Exc', type: 'boolean-exception-null' },
  { key: 'turn', label: 'Turno', type: 'turn' },
  { key: 'businessName', label: 'Cliente' },
  { key: 'amount', label: 'Monto', type: 'money' },
  { key: 'minutesSinceUpdate', label: 'Estancado', type: 'formatMinutes' },
  { key: 'createdAt', label: 'Creado en', type: 'date-large' },
  { key: 'status', label: 'Estado', type: 'status' },
  { key: 'recipientName', label: 'Ejecutivo' },
  { key: 'createdBy', label: 'Creado por' },
];

const MyRequestsToApprove: React.FC<MyRequestsToApproveProps> = ({
  open,
  onClose,
  handleDetails,
}) => {
  const dispatch = useDispatch();
  const { data: requests = { data: [] }, isLoading: loading } =
    getFactoringRequestsReceivedToApprove(dispatch, { enabled: open });

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="xl"
      fullWidth
      PaperProps={{
        sx: {
          minHeight: '80vh',
          maxHeight: '90vh',
        },
      }}
    >
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h5" component="div" sx={{ fontWeight: 600 }}>
            Solicitudes Pendientes de Aprobación
          </Typography>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ p: 0 }}>
        {loading ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="400px"
          >
            <CenteredCircularProgress type="dialog" />
          </Box>
        ) : (
          <Box sx={{ p: 2 }}>
            <HeaderWithActions
              title="Acá podrás ver todas tus solicitudes de factoring pendientes de aprobación."
              variant="body1"
            />
            <EnhancedTable
              data={requests.data}
              dataHeaders={dataHeaders}
              handleClickRow={handleDetails}
              exportToFile="xlsx"
              rowsPerPageDefault={10}
            />
          </Box>
        )}
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <CustomButton onClick={handleClose} color="secondary">
          Cerrar
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default MyRequestsToApprove;
